export const fieldTypes = {
    TEXT: 'text',
    SELECT: 'select',
    MULTY_SELECT: 'multySelect',
    PHONE: 'phone',
    EMAIL: 'email',
    CONSENT: 'boolean',
    DATE: 'date'
}

export const fieldSizes = {
    FULL: 'full',
    HALF: 'half',
    THIRD: 'third'
}

export const consentTypes = {
    LINK: 'link',
    UPLOADED: 'uploaded',
    TEXT: 'text'
}

export const skipTypes = {
    NO_SKIP: '',
    SKIP_ICON: 'icon',
    SKIP_BUTTON: 'button'
}